/* ============================================================
   Maison Atelier Premium — shop-the-look.js
   Punti cliccabili sull'immagine → evidenzia la card prodotto
   ============================================================ */
(function () {
  'use strict';
  document.querySelectorAll('[data-stl]').forEach(function (stl) {
    var dots = stl.querySelectorAll('[data-stl-dot]');
    var pins = stl.querySelectorAll('[data-stl-pin]');

    function activate(id) {
      pins.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-stl-pin') === id); });
      var target = stl.querySelector('[data-stl-pin="' + id + '"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { activate(dot.getAttribute('data-stl-dot')); });
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(dot.getAttribute('data-stl-dot')); }
      });
    });
  });
})();
